import React from 'react'
import styles from './Banners.module.scss'
import SvgGenerator from 'components/svgGenerator/SvgGenerator'
import strings from 'assets/strings'

type BannerProps = {
    title: string;
    content: string;
    icon: string;
    isPhone: boolean;
    extraData: string;
}

function Banners({ banners }: { banners: BannerProps[] }) {
    return (
        <div className={styles.container}>
            {banners.map((banner, index) => (
                <div className={styles.banner}>
                    <div key={index} className={styles.iconTextWrapper}>
                        <figure className={styles.figure}>
                            <img src={banner.icon} alt="icon" className={styles.roundedCircle} />
                        </figure>
                        <div>
                            <div className={styles.title}>{banner.title}</div>
                            <div className={styles.content}>{banner.content}</div>
                            {banner.isPhone &&
                                <div className={styles.phoneContainer}>                                   
                                    <div className={styles.iconWrapper}>
                                        <SvgGenerator name="BannerPhone" objectName='medicalCenterSearchResults' />
                                    </div>
                                    <span className={styles.extraDataPhone}>{banner.extraData}</span>
                                </div>
                            }
                        </div>
                    </div>
                    {!banner.isPhone &&
                        <div className={styles.infoWrapper}>
                            <a href={banner.extraData} className={styles.moreInfo}>{strings.medicalCentersSearchResults.moreInfo}</a>
                            <SvgGenerator name="ArrowDownWhite" objectName='medicalCenterSearchResults' />
                        </div>
                    }
                </div>
            ))}
        </div>
    )
}

export default Banners